import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { useAppDispatch } from 'state'
import { updateLocalCurrencyFxRates } from 'state/info/actions'

const INTERNAL_FIAT_EXCHANGE_RATE = 'https://price-api.crypto.com/price/v1/currency/all'

export const useLocalCurrencyExRate = () => {
  const dispatch = useAppDispatch()
  const { data: res } = useQuery(
    ['fetch-fiat-currency-fx-rate'],
    () => fetch(INTERNAL_FIAT_EXCHANGE_RATE).then((data) => data.json()),
    {
      refetchInterval: 3_600_000,
      cacheTime: 3_600_000,
    },
  )
  useEffect(() => {
    if (res?.data?.fiat) dispatch(updateLocalCurrencyFxRates({ fxRateMap: res.data.fiat }))
  }, [res, dispatch])
}
